<template>
    <div class="interactive-map">
        <div v-if="geos.length" class="map">
            <RegionMap
                :geos="geos"
                :format-value="metric.format ?? String"
                :bands="metric.bands"
                :legend-format="metric.legend?.format"
                :legend-caption="metric.legend?.caption"
                :legend-inverted="metric.legend?.inverted"
                popup-on="hover"
            >
                <template #popup="{ geos: hovered }">
                    <ul class="map-popup-card">
                        <MapPopupCard
                            v-for="item in popupItems(hovered)"
                            :key="item.id"
                            :title="item.title"
                            :lines="item.lines"
                            :progress="item.progress"
                        />
                    </ul>
                </template>
            </RegionMap>
        </div>
        <MobileMapOverlay />
    </div>
    <ul class="map-options">
        <li
            v-for="option in metrics"
            :key="option.key"
            :class="{ selected: option.key === selected }"
            @click="selected = option.key"
        >
            {{ option.label }}
        </li>
    </ul>
</template>

<script>
import RegionMap from "js/components/maps/RegionMap";
import MapPopupCard from "js/components/maps/MapPopupCard";
import MobileMapOverlay from "js/components/blocks/MobileMapOverlay";
import { Geo } from "js/lib/geocoding.js";

export default {
    name: "MetricRegionMap",
    components: { RegionMap, MapPopupCard, MobileMapOverlay },
    props: {
        entries: {
            type: Array,
            default: () => [],
        },
        metrics: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selected: this.metrics[0].key,
        };
    },
    computed: {
        metric() {
            return this.metrics.find((option) => option.key === this.selected);
        },
        geos() {
            return this.entries.map((entry) =>
                new Geo(entry.geo).setValue(entry[this.selected]).setMeta(entry)
            );
        },
    },
    methods: {
        popupItems(geos) {
            return geos.map((geo) => {
                const card = this.metric.popup?.(geo.getMeta());
                if (!card) {
                    return {
                        id: geo.country_code,
                        title: `${geo.getFlag()} ${geo.country}`,
                        lines: [this.describe(geo.getValue())],
                    };
                }

                return {
                    id: geo.country_code,
                    title: `${geo.getFlag()} ${geo.country}`,
                    lines: [card.title, ...(card.lines ?? [])],
                    progress: card.progress,
                };
            });
        },
        describe(value) {
            if (this.metric.tooltip) {
                return this.metric.tooltip(value);
            }
            const [one, many] = this.metric.unit;

            return `${value} ${value === 1 ? one : many}`;
        },
    },
};
</script>
